<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <div>
        <h1 class="mt-2 text-3xl text-gray-900">Editar Perfil</h1>
        <p class="mt-2 max-w-2xl text-sm text-gray-500">Atualize seus dados pessoais, senha e preferências de notificação.</p>
      </div>

      <form autocomplete="off" class="space-y-6">
        <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div class="p-6">
            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div class="flex flex-col gap-1">
                <label for="name" class="text-sm font-medium text-gray-500">Nome</label>
                <input
                  v-model="form.nome"
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Digite seu nome..."
                  class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                />
              </div>

              <div class="flex flex-col gap-1">
                <label for="email" class="text-sm font-medium text-gray-500">Email</label>
                <input
                  v-model="form.email"
                  type="text"
                  name="email"
                  id="email"
                  placeholder="Digite seu email..."
                  class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                />
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
              <div v-if="!alterarPassword" class="flex items-end">
                <button @click="alterarPassword = true" type="button" class="h-11 w-full rounded-xl bg-blue-500 px-5 font-medium text-white transition hover:bg-blue-600 md:w-auto">Alterar senha</button>
              </div>

              <div v-if="$store.state.user.operador" class="rounded-2xl border border-gray-200 bg-gray-50 p-4">
                <p class="text-sm font-medium text-gray-700">Notificações do navegador</p>
                <p class="mt-1 text-xs text-gray-400">Ative ou desative os alertas enviados pelo navegador.</p>

                <button v-if="!$store.state.user.notifcacaoNavegador" @click="subscribeToPush" type="button" class="mt-4 h-11 rounded-xl bg-green-600 px-5 text-sm font-medium text-white transition hover:bg-green-700">
                  Ativar Notificações
                </button>

                <button v-else @click="subscribeCancel" type="button" class="mt-4 h-11 rounded-xl bg-red-700 px-5 text-sm font-medium text-white transition hover:bg-red-800">Desativar Notificações</button>
              </div>
            </div>
          </div>
        </div>

        <div class="rounded-2xl border border-gray-200 bg-white p-6">
          <label for="passwordAtual" class="text-sm font-medium text-gray-500">Senha atual (obrigatoria para mudar e-mail ou senha)</label>
          <input id="passwordAtual" v-model="form.passwordAtual" type="password" autocomplete="current-password" class="mt-2 h-11 w-full rounded-xl border border-gray-200 px-4" />
        </div>

        <div v-if="alterarPassword" class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div class="p-6">
            <h2 class="text-lg font-medium text-gray-800">Alterar senha</h2>
            <p class="mt-1 text-sm text-gray-500">Informe e confirme sua nova senha.</p>

            <div class="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2">
              <div class="flex flex-col gap-1">
                <label for="password" class="text-sm font-medium text-gray-500">Senha</label>

                <div class="relative">
                  <input
                    autocomplete="new-password"
                    v-model="form.password"
                    :type="mostrarSenha ? 'text' : 'password'"
                    name="password"
                    id="password"
                    placeholder="Nova senha..."
                    class="h-11 w-full rounded-xl border border-gray-200 px-4 pr-11 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                  />

                  <button type="button" @click="mostrarSenha = !mostrarSenha" class="absolute inset-y-0 right-3 flex items-center text-gray-300 transition hover:text-gray-500">
                    <svg v-if="!mostrarSenha" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0Z" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7Z" />
                    </svg>

                    <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3l18 18" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.584 10.587A2 2 0 0012 14a2 2 0 001.414-.586" />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9.879 5.583A10.01 10.01 0 0112 5c4.478 0 8.268 2.943 9.542 7a9.964 9.964 0 01-2.043 3.368M6.228 6.228C4.521 7.352 3.229 9.015 2.458 12c1.274 4.057 5.065 7 9.542 7a9.98 9.98 0 004.132-.892"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              <div class="flex flex-col gap-1">
                <label for="password2" class="text-sm font-medium text-gray-500">Confirme a senha</label>

                <div class="relative">
                  <input
                    autocomplete="new-password"
                    v-model="form.password2"
                    :type="mostrarConfirmarSenha ? 'text' : 'password'"
                    name="password2"
                    id="password2"
                    placeholder="Confirme a nova senha..."
                    class="h-11 w-full rounded-xl border border-gray-200 px-4 pr-11 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                  />
                  <button type="button" @click="mostrarConfirmarSenha = !mostrarConfirmarSenha" class="absolute inset-y-0 right-3 flex items-center text-gray-300 transition hover:text-gray-500">
                    <svg v-if="!mostrarConfirmarSenha" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0Z" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7Z" />
                    </svg>

                    <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3l18 18" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.584 10.587A2 2 0 0012 14a2 2 0 001.414-.586" />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9.879 5.583A10.01 10.01 0 0112 5c4.478 0 8.268 2.943 9.542 7a9.964 9.964 0 01-2.043 3.368M6.228 6.228C4.521 7.352 3.229 9.015 2.458 12c1.274 4.057 5.065 7 9.542 7a9.98 9.98 0 004.132-.892"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-between">
          <button
            @click="voltar"
            type="button"
            class="icon-anim-trigger--back group flex h-11 items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-5 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:bg-gray-50 hover:shadow-md sm:w-auto"
          >
            <svg class="icon-anim icon-anim--back h-5 w-5 text-gray-500 group-hover:text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
            Voltar
          </button>

          <button @click="save" type="button" class="h-11 rounded-xl bg-blue-500 px-6 font-medium text-white transition hover:bg-blue-600">Salvar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alterarPassword: false,
      mostrarSenha: false,
      mostrarConfirmarSenha: false,
      form: {
        nome: "",
        email: "",
        password: "",
        passwordAtual: "",
        password2: ""
      }
    };
  },

  methods: {
    async save() {
      if (!this.form.email) {
        return this.$vToastify.error("Digite o email");
      }

      if (this.alterarPassword && !this.form.password) {
        return this.$vToastify.error("Digite a senha");
      }

      if (this.alterarPassword && this.form.password !== this.form.password2) {
        return this.$vToastify.error("Senhas não coincidem");
      }

      const mudaCredencial = !!this.form.password || this.form.email !== this.$store.state.user.email;
      if (mudaCredencial && !this.form.passwordAtual) return this.$vToastify.error("Informe a senha atual.");
      let req;
      try { req = await this.$http.put(this.$store.state.user.operador ? `/v1/operador` : "/v1/users", this.form); } catch (erro) {
        return this.$vToastify.error((erro.response && erro.response.data && erro.response.data.err) || "Nao foi possivel salvar.");
      }

      if (req.data.success) {
        this.$vToastify.success("Salvo com sucesso!");
        if (mudaCredencial) {
          this.$store.commit("logout");
          return this.$router.push({ path: "/login" });
        }
        this.$router.push({ path: `/operadores` });
      } else {
        this.$vToastify.error(req.data.err);
      }
    },

    voltar() {
      const user = this.$store.state.user;

      if (user.operador && user.chatAcesso) {
        return this.$router.push({ path: "/chat" });
      }

      if (!user.chatAcesso && user.visualizarChat) {
        return this.$router.push({ path: "/chat" });
      }

      if (user.operador && !user.chatAcesso) {
        return this.$router.push({ path: "/campanhas" });
      }

      if (user.lzv2 && user.lzv2.upload) {
        if (user.lzv2.respostas && user.acessos_lzv2?.includes("relatorio_chats")) {
          return this.$router.push({ path: "/" });
        } else {
          return this.$router.push({ path: "/campanhas" });
        }
      }

      if (user.lzv2 && user.lzv2.validacao) {
        return this.$router.push({ path: "/temzap" });
      }

      return this.$router.push({ path: "/operadores" });
    },

    urlBase64ToUint8Array(base64String) {
      const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
      const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
      const rawData = window.atob(base64);

      return new Uint8Array([...rawData].map((char) => char.charCodeAt(0)));
    },

    async subscribeToPush() {
      const publicVapidKey = process.env.VUE_APP_KEYWEBPUSH;

      if (!("serviceWorker" in navigator)) {
        console.error("Service Worker não suportado!");
        return;
      }

      const permission = await Notification.requestPermission();

      if (permission !== "granted") {
        console.error("Permissão negada pelo usuário.");
        return this.$vToastify.error("Necessário acionar permissão de notificação do navegador");
      }

      const register = await navigator.serviceWorker.ready;

      let existingSubscription = await register.pushManager.getSubscription();

      if (existingSubscription) {
        console.log("Removendo assinatura antiga...");
        await existingSubscription.unsubscribe();
      }

      const subscription = await register.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: this.urlBase64ToUint8Array(publicVapidKey)
      });

      const subscriptionData = subscription.toJSON();

      await this.$http.put(`/v1/operador`, {
        notifcacaoNavegador: true,
        endpoint: subscriptionData.endpoint,
        keys: {
          auth: subscriptionData.keys.auth,
          p256dh: subscriptionData.keys.p256dh
        }
      });

      window.location.reload();
    },

    async subscribeCancel() {
      await this.$http.put(`/v1/operador`, {
        notifcacaoNavegador: false,
        endpoint: "",
        keys: {
          auth: "",
          p256dh: ""
        }
      });

      window.location.reload();
    }
  },

  async beforeMount() {
    const userReq = await this.$http.post("/v1/users/meLZV2");

    this.form = {
      _id: userReq.data._id,
      email: userReq.data.email,
      nome: userReq.data.nome,
      password: "",
      passwordAtual: "",
      password2: ""
    };
  }
};
</script>
